// extracted by mini-css-extract-plugin
module.exports = {"alert_card":"ItemTypeDetailScreen_alert_card__3RFC0","toggle":"ItemTypeDetailScreen_toggle__wgpSD","red_text":"ItemTypeDetailScreen_red_text__1Ry5L"};